// components/Titles/TitlesForm.jsx - Version mise à jour
import { useEffect, useState } from "react";
import { useUser } from "@clerk/clerk-react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import useSelectedDomain from "../../service/Hooks/useSelectedDomain";
import { getUserRole } from "../../service/api/AuthRoleService";
import AllSecuritiesModal from "./Modal/AllSecuritiesModal";
import SecurityForm from "./SecurityForm"; // Importer le nouveau composant

const TitlesForm = () => {
    const { user } = useUser();
    const location = useLocation();
    const [role, setRole] = useState(null);
    const selectedDomain = useSelectedDomain();
    const [showAllSecuritiesModal, setShowAllSecuritiesModal] = useState(false);
    const [selectedSecurityId, setSelectedSecurityId] = useState(null);

    useEffect(() => {
        const fetchUserRole = async () => {
            if (!user) return;
            try {
                const fetchedRole = await getUserRole(user, selectedDomain);
                setRole(fetchedRole);
            } catch (error) {
                toast.error("Erreur lors de la récupération du rôle");
                setRole("client");
            }
        };

        fetchUserRole();
    }, [user, selectedDomain]);

    /**
     * Gérer le succès de la création/modification
     */
    const handleSecuritySuccess = (security, isNew) => {
        toast.success(isNew ? 'Titre créé avec succès' : 'Titre mis à jour avec succès');
        // Rafraîchir la page ou les données si nécessaire
        window.location.reload(); // Ou utiliser un état de rafraîchissement
    };

    /**
     * Ouvrir le formulaire en mode édition
     */
    const handleEditSecurity = (securityId) => {
        setSelectedSecurityId(securityId);
        // Le modal s'ouvre automatiquement avec data-bs-target
        const modal = document.getElementById('moredetailSecurities');
        if (modal) {
            const bsModal = new bootstrap.Modal(modal);
            bsModal.show();
        }
    };

    return (
        <>
            {/* Page pour la gestion des titres */}
            <div className="page-titles">
                <nav className="breadcrumb-modern" aria-label="breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <span className="breadcrumb-main text-uppercase letter-spacing">Titres</span>
                    </li>
                    </ol>
                </nav>
                
                <div className="page-actions d-flex gap-3">
                    {/* Bouton existant pour nouveau titre */}
                    {(role === "admin+manager" || role === "admin") && (
                        <button 
                            className="btn btn-primary btn-new-order marge"
                            data-bs-toggle="modal" 
                            data-bs-target="#moredetailSecurities"
                            onClick={() => setSelectedSecurityId(null)} // Mode création
                        >
                            <span className="btn-text">Nouveau Titre</span>
                            <span className="btn-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z" fill="currentColor"/>
                                    <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z" fill="currentColor"/>
                                </svg>
                            </span>
                        </button>
                    )}

                    {/* Nouveau bouton pour voir tous les titres */}
                    <button 
                        className="btn btn-primary btn-new-order"
                        onClick={() => setShowAllSecuritiesModal(true)}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 8V6C21 4.35 19.65 3 18 3H6C4.35 3 3 4.35 3 6V8H21Z" fill="currentColor"/>
                            <path d="M21 10H3V18C3 19.65 4.35 21 6 21H18C19.65 21 21 19.65 21 18V10ZM8 17H6V15H8V17ZM8 14H6V12H8V14ZM8 11H6V9H8V11ZM13.5 17H10.5V15H13.5V17ZM13.5 14H10.5V12H13.5V14ZM13.5 11H10.5V9H13.5V11ZM19 17H16V15H19V17ZM19 14H16V12H19V14ZM19 11H16V9H19V11Z" fill="currentColor"/>
                        </svg>
                        <span className="btn-text">Voir Tous les Titres</span>
                    </button>
                </div>
            </div>

            {/* Modal pour tous les titres */}
            <AllSecuritiesModal 
                show={showAllSecuritiesModal}
                onHide={() => setShowAllSecuritiesModal(false)}
                onEditSecurity={handleEditSecurity} // Passer la fonction d'édition
            />

            {/* Formulaire de titre unifié */}
            <SecurityForm
                securityId={selectedSecurityId}
                modalId="moredetailSecurities" // Même ID que votre bouton
                onSuccess={handleSecuritySuccess}
                onClose={() => setSelectedSecurityId(null)}
            />
        </>
    );
};

export default TitlesForm;